module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('partial-loader', {
    attrs: {
      "loading": _vm.isFetching
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [(!_vm.isFetching && _vm.bidNumbers.length > 0) ? _c('table', {
    staticClass: "table b-table table-striped table-hover"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.bidNumbers), function(bidNumber) {
    return _c('tr', [_c('td', [_c('h3', [_vm._v(_vm._s(bidNumber.bid_number))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(bidNumber.auction.title))]), _vm._v(" "), _c('td', [_c('b-btn', {
      attrs: {
        "variant": "outline-danger",
        "size": "sm"
      },
      on: {
        "click": function($event) {
          return _vm.showDeleteModal(bidNumber)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-fw fa-trash"
    })])], 1)])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.bidNumbers.length === 0) ? _c('p', [_vm._v("\n\t\t\tNog geen biednummers.\n\t\t")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [(_vm.formError) ? _c('b-alert', {
    attrs: {
      "show": "",
      "variant": "warning"
    }
  }, _vm._l((_vm.formError.errors), function(errors) {
    return _c('span', _vm._l((errors), function(error) {
      return _c('span', [_vm._v(_vm._s(error)), _c('br')])
    }), 0)
  }), 0) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col col-sm-3"
  }, [_c('b-form-group', {
    attrs: {
      "label": "Biednummer:"
    }
  }, [_c('b-form-input', {
    attrs: {
      "autocomplete": "off"
    },
    model: {
      value: (_vm.form.bid_number),
      callback: function($$v) {
        _vm.$set(_vm.form, "bid_number", $$v)
      },
      expression: "form.bid_number"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('autocomplete-auction', {
    attrs: {
      "label": "Veiling",
      "selected": _vm.form,
      "placeholderLabel": ""
    },
    on: {
      "update:auction": _vm.updateAuctionId
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-2"
  }, [_c('b-form-group', {
    attrs: {
      "label": "&nbsp;"
    }
  }, [_c('b-btn', {
    attrs: {
      "variant": "outline-primary",
      "block": ""
    },
    on: {
      "click": _vm.addBidNumber
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-plus"
  })])], 1)], 1)])]), _vm._v(" "), _c('delete-dialog-modal', {
    ref: "deleteModal",
    attrs: {
      "delete-name": _vm.getDeleteTitle(),
      "item": _vm.bidNumberToDelete,
      "isDeleting": _vm.isDeleting
    },
    on: {
      "confirm": _vm.deleteBidNumber
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Biednummer")]), _vm._v(" "), _c('th', [_vm._v("Veiling")]), _vm._v(" "), _c('th')])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6b77a4e9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Person/Form/PersonBidNumbers.vue
// module id = 1324
// module chunks = 1